import api from "./Api";

class TipoOrdemServicoService {
  GetTipoOrdemServico(payload) {
    return api.get("/v1/tipoOrdemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTipoOrdemServico(payload) {
    return api.post("/v1/tipoOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  PutTipoOrdemServico(payload) {
    return api.put("/v1/tipoOrdemServico/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTipoOrdemServico(payload) {
    return api.delete("/v1/tipoOrdemServico/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTipoOrdemServicoOData(payload) {
    return api.get("/OData/TipoOrdemServico" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TipoOrdemServicoService();
